import { Subject } from 'rxjs';

export class Timer {
  onStart = new Subject<void>();
  onTick = new Subject<void>();
  onPeriod = new Subject<void>();
  onStop = new Subject<void>();
  onEnd = new Subject<void>();

  elapsed = 0;
  intervalId: NodeJS.Timeout | undefined;

  private handlerOnTick() {
    ++this.elapsed;
    this.onTick.next();
    if (this.period && this.elapsed % this.period === 0) this.onPeriod.next();
    if (this.limit > 0 && this.elapsed >= this.limit) {
      this.end();
    }
  }

  constructor(
    /** @desc Время в секундах до завершения таймера. По остановке вызывается onEnd */
    public limit: number,

    /** @desc Кол-во секунд, по истечении которых таймер будет дополнительно сообщать onPeriod (неоднократно) */
    public period?: number | undefined
  ) {}

  reset() {
    this.stop();
    this.elapsed = 0;
  }

  restart() {
    if (!this.intervalId) return false;
    this.elapsed = 0;
    return true;
  }

  start() {
    if (this.intervalId) return false;
    this.elapsed = 0;
    this.intervalId = setInterval(this.handlerOnTick.bind(this), 1000);
    this.onStart.next();
    return true;
  }

  stop() {
    if (!this.intervalId) return false;
    clearInterval(this.intervalId);
    this.intervalId = undefined;
    this.onStop.next();
    return true;
  }

  end() {
    this.stop();
    this.onEnd.next();
  }

  formatTime(time: number) {
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;

    const numberTo2DigitString = (num: number): string => {
      if (num < 10) return '0' + num.toString();
      return num.toString();
    };

    return `${numberTo2DigitString(minutes)}:${numberTo2DigitString(seconds)}`;
  }
}
